<template>
  <form @submit.prevent="submit">
    <AhaInputTag
      class="mb-2"
      v-model="tags"
      :allow-duplicate="false"
      :placeholder="tags.length === 0 ? inputTagPlaceHolder : ''"
    />

    <AhaButton type="submit" :submitting="isSubmitting">
      {{ $i18nPresenter.t('Save') }}
    </AhaButton>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

// utils
import utils from '@/util'

// api
import PresentationAPI from '@/api/presentation'

export default {
  data() {
    return {
      tags: [],
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    inputTagPlaceHolder() {
      return this.$i18nPresenter.t('Enter tags, comma separated')
    },
  },
  mounted() {
    this.tags = this.presentation.tags || this.tags
  },
  methods: {
    ...mapActions(['patchPresentationAction']),
    async submit() {
      this.isSubmitting = true
      const payload = {
        tags: this.tags,
      }

      try {
        await PresentationAPI.patchPresentation(this.presentation.id, payload)
        utils.showToastSuccess(`${this.$i18nPresenter.t('Saved')} ${this.tags.length} ${this.$i18nPresenter.t('tag(s)')}`)
      } catch {
        utils.showToastError(this.$i18nPresenter.t('Saved failed. Should alert development team.'))
        return
      } finally {
        this.isSubmitting = false
      }

      this.patchPresentationAction(payload)
    },
  },
}
</script>
